import React from "react";
import { useTranslation } from "react-i18next";
import AnimatedElement from "../AnimatedElement";

import "../../i18next";

import bogota from "../../assets/images/Nosotros/bogota_headq.png";
import centroAmerica from "../../assets/images/Nosotros/guatemala_headq.png";
import atlanta from "../../assets/images/Nosotros/atlanta_headq.png";

function Nosotros5() {
  const { t } = useTranslation();

  return (
    <section className="px-6 md:px-28 py-16">
      {/* Título */}
      <AnimatedElement
        fromDirection="left"
        className="text-white font-bold text-2xl md:text-4xl mb-4"
        style={{ fontFamily: "Helvetica" }}
      >
        <h2>{t("aboutUs.ourLocations")}</h2>
      </AnimatedElement>

      {/* Subtítulo */}
      <AnimatedElement
        fromDirection="left"
        className="text-white text-base md:text-xl mb-12"
        style={{ fontFamily: "Helvetica" }}
      >
        {t("aboutUs.findUs")}
      </AnimatedElement>

      {/* Grid de ubicaciones */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
        {/* ATLANTA */}
        <AnimatedElement fromDirection="bottom" className="text-white">
          <img
            src={atlanta}
            alt="Atlanta"
            className="w-full object-contain mb-6"
          />
          <h2
            className="font-bold text-xl md:text-2xl mb-4"
            style={{ fontFamily: "Helvetica" }}
          >
            Headquarters - Atlanta, USA
          </h2>
          <p
            className="text-sm md:text-base"
            style={{ fontFamily: "Helvetica" }}
          >
            • {t("aboutUs.logisticCenter")} <br />• {t("aboutUs.repairCenter")}{" "}
            <br />• {t("aboutUs.netScholl")} <br />
          </p>
          <p
            className="font-bold mt-4 text-sm md:text-base"
            style={{ fontFamily: "Helvetica" }}
          >
            {t("contacto.textImg1")}
          </p>
        </AnimatedElement>

        {/* BOGOTÁ */}
        <AnimatedElement fromDirection="bottom" className="text-white">
          <img
            src={bogota}
            alt="Bogotá"
            className="w-full object-contain mb-6"
          />
          <h2
            className="font-bold text-xl md:text-2xl mb-4"
            style={{ fontFamily: "Helvetica" }}
          >
            Bogotá, Colombia /<br /> Guayaquil, Ecuador
          </h2>
          <p
            className="text-sm md:text-base"
            style={{ fontFamily: "Helvetica" }}
          >
            • {t("aboutUs.logisticCenter")} <br />• {t("aboutUs.repairCenter")}{" "}
            <br />• {t("aboutUs.netScholl")} <br />
          </p>
          <p
            className="font-bold mt-4 text-sm md:text-base"
            style={{ fontFamily: "Helvetica" }}
          >
            {t("contacto.textImg2")}
          </p>
        </AnimatedElement>

        {/* GUATEMALA */}
        <AnimatedElement fromDirection="bottom" className="text-white">
          <img
            src={centroAmerica}
            alt="Guatemala"
            className="w-full object-contain mb-6"
          />
          <h2
            className="font-bold text-xl md:text-2xl mb-4"
            style={{ fontFamily: "Helvetica" }}
          >
            Ciudad de Guatemala, <br /> Guatemala
          </h2>
          <p
            className="text-sm md:text-base"
            style={{ fontFamily: "Helvetica" }}
          >
            • {t("aboutUs.logisticCenter")} <br />• {t("aboutUs.repairCenter")}{" "}
            <br />• {t("aboutUs.netScholl")} <br />
          </p>
          <p
            className="font-bold mt-4 text-sm md:text-base"
            style={{ fontFamily: "Helvetica" }}
          >
            {t("contacto.textImg3")}
          </p>
        </AnimatedElement>
      </div>
    </section>
  );
}

export default Nosotros5;
